module.exports = __webpack_public_path__ + "img/sz-icon.8fdceb1c.svg";